// ===================================================================
// robinScheduleConfig.js  (ESM / src 正本)
// ROBIN_ORDER       : 運営現場最適化済の対戦順 (触禁定数)
// MATCHES_PER_BLOCK : ペア数ごとの総試合数 (nextSchedule内ローカル定数から昇格)
//
// ★src/shared が正 (single source of truth・ESM)。
//   functions/shared/ へは predeploy で CJS変換してコピー (編集はこちらのみ)。
// ===================================================================

export const ROBIN_ORDER = {
  3: [[1, 2], [1, 3], [2, 3]],
  4: [[1, 2], [3, 4], [1, 3], [2, 4], [1, 4], [2, 3]],
  5: [[1, 2], [3, 4], [1, 5], [2, 3], [4, 5], [1, 3], [2, 4], [3, 5], [1, 4], [2, 5]],
  6: [
    [1, 2], [5, 6], [1, 3], [4, 6], [3, 5], [1, 4],
    [2, 6], [1, 5], [3, 6], [2, 4], [4, 5], [2, 3],
  ],
};

export const MATCHES_PER_BLOCK = { 3: 3, 4: 6, 5: 10, 6: 12 };
